/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LoteResponse } from '../models/lote-response';
import { LoteHonorario } from '../models/lote-honorario';
import { LoteHonorarioPaginado } from '../models/lote-honorario-paginado';
import { Message } from '../models/message';
import { RequestLoteHonorarioType } from '../models/request-lote-honorario-type';

/**
 * API responsavel pelos dados do lote de honorario
 */
@Injectable({
  providedIn: 'root',
})
class LoteHonorarioService extends __BaseService {
  static readonly salvarLoteHonorarioPath = '/lote-honorario';
  static readonly obterLotesPath = '/lote-honorario';
  static readonly obterRelatorioLotePath = '/lote-honorario/relatorio';
  static readonly reprovarLotePath = '/lote-honorario/reprovar';
  static readonly cancelarLotePath = '/lote-honorario/cancelar';
  static readonly aprovarLotePath = '/lote-honorario/aprovar';
  static readonly voltaStatusPath = '/lote-honorario/volta';
  static readonly obterLotePorNumeroPath = '/lote-honorario/detalhe/{numeroLote}';
  static readonly obterLotePaginadoPorNumeroPath = '/lote-honorario/detalhe/{numeroLote}/{page}/{perPage}';
  static readonly obterNotaFiscalHonorarioPath = '/lote-honorario/nota-fiscal/{idArquivo}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Cadastra um lote de honorario
   * @param loteHonorario Objeto do lote
   * @return Operacao realizada com sucesso
   */
  salvarLoteHonorarioResponse(loteHonorario: LoteHonorario): __Observable<__StrictHttpResponse<LoteResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = loteHonorario;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-honorario`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteResponse>;
      })
    );
  }
  /**
   * Cadastra um lote de honorario
   * @param loteHonorario Objeto do lote
   * @return Operacao realizada com sucesso
   */
  salvarLoteHonorario(loteHonorario: LoteHonorario): __Observable<LoteResponse> {
    return this.salvarLoteHonorarioResponse(loteHonorario).pipe(
      __map(_r => _r.body as LoteResponse)
    );
  }

  /**
   * Recupera uma listagem dos lotes com base nos parametros informados
   * @param params The `LoteHonorarioService.ObterLotesParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `situacaoLote`: Situação do lote
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroLote`: Numero do lote
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Numero do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterLotesResponse(params: LoteHonorarioService.ObterLotesParams): __Observable<__StrictHttpResponse<LoteHonorarioPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.valorInicial != null) __params = __params.set('valorInicial', params.valorInicial.toString());
    if (params.valorFinal != null) __params = __params.set('valorFinal', params.valorFinal.toString());
    if (params.situacaoLote != null) __params = __params.set('situacaoLote', params.situacaoLote.toString());
    if (params.periodoInicial != null) __params = __params.set('periodoInicial', params.periodoInicial.toString());
    if (params.periodoFinal != null) __params = __params.set('periodoFinal', params.periodoFinal.toString());
    if (params.perPage != null) __params = __params.set('perPage', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroLote != null) __params = __params.set('numeroLote', params.numeroLote.toString());
    if (params.codigoEscritorio != null) __params = __params.set('codigoEscritorio', params.codigoEscritorio.toString());
    if (params.anoSinistro != null) __params = __params.set('anoSinistro', params.anoSinistro.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lote-honorario`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteHonorarioPaginado>;
      })
    );
  }
  /**
   * Recupera uma listagem dos lotes com base nos parametros informados
   * @param params The `LoteHonorarioService.ObterLotesParams` containing the following parameters:
   *
   * - `valorInicial`: Faixa de valor inicial na pesquisa
   *
   * - `valorFinal`: Faixa de valor final na pesquisa
   *
   * - `situacaoLote`: Situação do lote
   *
   * - `periodoInicial`: Data inicial da pesquisa
   *
   * - `periodoFinal`: Data final da pesquisa
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroLote`: Numero do lote
   *
   * - `codigoEscritorio`: Codigo do escritorio
   *
   * - `anoSinistro`: Numero do sinistro
   *
   * @return Operacao realizada com sucesso
   */
  obterLotes(params: LoteHonorarioService.ObterLotesParams): __Observable<LoteHonorarioPaginado> {
    return this.obterLotesResponse(params).pipe(
      __map(_r => _r.body as LoteHonorarioPaginado)
    );
  }

  /**
   * Retorna relatorio de lotes com base na lista de parcela passada
   * @param relatorioRequest Objeto relatorio request
   * @return Relatório gerado com sucesso
   */
  obterRelatorioLoteResponse(relatorioRequest?: Array<LoteHonorario>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = relatorioRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-honorario/relatorio`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Retorna relatorio de lotes com base na lista de parcela passada
   * @param relatorioRequest Objeto relatorio request
   * @return Relatório gerado com sucesso
   */
  obterRelatorioLote(relatorioRequest?: Array<LoteHonorario>): __Observable<Blob> {
    return this.obterRelatorioLoteResponse(relatorioRequest).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Reprova um lote
   * @param RequestLoteHonorarioType Informacoes do lote a ser aprovado
   * @return Operacao realizada com sucesso
   */
  reprovarLoteResponse(RequestLoteHonorarioType: RequestLoteHonorarioType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestLoteHonorarioType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-honorario/reprovar`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Reprova um lote
   * @param RequestLoteHonorarioType Informacoes do lote a ser aprovado
   * @return Operacao realizada com sucesso
   */
  reprovarLote(RequestLoteHonorarioType: RequestLoteHonorarioType): __Observable<Message> {
    return this.reprovarLoteResponse(RequestLoteHonorarioType).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Cancela um lote
   * @param RequestLoteHonorarioType Informacoes do lote a ser aprovado
   * @return Operacao realizada com sucesso
   */
  cancelarLoteResponse(RequestLoteHonorarioType: RequestLoteHonorarioType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestLoteHonorarioType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-honorario/cancelar`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Cancela um lote
   * @param RequestLoteHonorarioType Informacoes do lote a ser aprovado
   * @return Operacao realizada com sucesso
   */
  cancelarLote(RequestLoteHonorarioType: RequestLoteHonorarioType): __Observable<Message> {
    return this.cancelarLoteResponse(RequestLoteHonorarioType).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Aprova um lote
   * @param RequestLoteHonorarioType Objeto lote request
   * @return Operacao realizada com sucesso
   */
  aprovarLoteResponse(RequestLoteHonorarioType?: RequestLoteHonorarioType): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = RequestLoteHonorarioType;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/lote-honorario/aprovar`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Aprova um lote
   * @param RequestLoteHonorarioType Objeto lote request
   * @return Operacao realizada com sucesso
   */
  aprovarLote(RequestLoteHonorarioType?: RequestLoteHonorarioType): __Observable<Message> {
    return this.aprovarLoteResponse(RequestLoteHonorarioType).pipe(
      __map(_r => _r.body as Message)
    );
  }

/**
   * Volta Status do lote
   * @param RequestLoteHonorarioType Objeto lote request
   * @return Operacao realizada com sucesso
   */
voltaStatusResponse(RequestLoteHonorarioType?: RequestLoteHonorarioType): __Observable<__StrictHttpResponse<Message>> {
  let __params = this.newParams();
  let __headers = new HttpHeaders();
  let __body: any = null;
  __body = RequestLoteHonorarioType;
  let req = new HttpRequest<any>(
    'POST',
    this.rootUrl + `/lote-honorario/volta`,
    __body,
    {
      headers: __headers,
      params: __params,
      responseType: 'json'
    });

  return this.http.request<any>(req).pipe(
    __filter(_r => _r instanceof HttpResponse),
    __map((_r) => {
      return _r as __StrictHttpResponse<Message>;
    })
  );
}
/**
 * Volta Status do lote
 * @param RequestLoteHonorarioType Objeto lote request
 * @return Operacao realizada com sucesso
 */
voltaStatus(RequestLoteHonorarioType?: RequestLoteHonorarioType): __Observable<Message> {
  return this.voltaStatusResponse(RequestLoteHonorarioType).pipe(
    __map(_r => _r.body as Message)
  );
}


  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param numeroLote Codigo identificador do lote
   * @return Operacao realizada com sucesso
   */
  obterLotePorNumeroResponse(numeroLote: number): __Observable<__StrictHttpResponse<LoteHonorario>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lote-honorario/detalhe/${encodeURIComponent(String(numeroLote))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteHonorario>;
      })
    );
  }
  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param numeroLote Codigo identificador do lote
   * @return Operacao realizada com sucesso
   */
  obterLotePorNumero(numeroLote: number): __Observable<LoteHonorario> {
    return this.obterLotePorNumeroResponse(numeroLote).pipe(
      __map(_r => _r.body as LoteHonorario)
    );
  }

  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param params The `LoteHonorarioService.ObterLotePaginadoPorNumeroParams` containing the following parameters:
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroLote`: Codigo identificador do lote
   *
   * @return Operacao realizada com sucesso
   */
  obterLotePaginadoPorNumeroResponse(params: LoteHonorarioService.ObterLotePaginadoPorNumeroParams): __Observable<__StrictHttpResponse<LoteHonorario>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lote-honorario/detalhe/${encodeURIComponent(String(params.numeroLote))}/${encodeURIComponent(String(params.page))}/${encodeURIComponent(String(params.perPage))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LoteHonorario>;
      })
    );
  }
  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param params The `LoteHonorarioService.ObterLotePaginadoPorNumeroParams` containing the following parameters:
   *
   * - `perPage`: Quantidade registros por pagina
   *
   * - `page`: Pagina inicial
   *
   * - `numeroLote`: Codigo identificador do lote
   *
   * @return Operacao realizada com sucesso
   */
  obterLotePaginadoPorNumero(params: LoteHonorarioService.ObterLotePaginadoPorNumeroParams): __Observable<LoteHonorario> {
    return this.obterLotePaginadoPorNumeroResponse(params).pipe(
      __map(_r => _r.body as LoteHonorario)
    );
  }

  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param idArquivo Codigo identificador do arquivo
   * @return Relatório gerado com sucesso
   */
  obterNotaFiscalHonorarioResponse(idArquivo: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/lote-honorario/nota-fiscal/${encodeURIComponent(String(idArquivo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Recupera uma listagem das transações com base nos parametros informados
   * @param idArquivo Codigo identificador do arquivo
   * @return Relatório gerado com sucesso
   */
  obterNotaFiscalHonorario(idArquivo: string): __Observable<Blob> {
    return this.obterNotaFiscalHonorarioResponse(idArquivo).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module LoteHonorarioService {

  /**
   * Parameters for obterLotes
   */
  export interface ObterLotesParams {

    /**
     * Faixa de valor inicial na pesquisa
     */
    valorInicial?: number;

    /**
     * Faixa de valor final na pesquisa
     */
    valorFinal?: number;

    /**
     * Situação do lote
     */
    situacaoLote?: number;

    /**
     * Data inicial da pesquisa
     */
    periodoInicial?: string;

    /**
     * Data final da pesquisa
     */
    periodoFinal?: string;

    /**
     * Quantidade registros por pagina
     */
    perPage?: number;

    /**
     * Pagina inicial
     */
    page?: number;

    /**
     * Numero do lote
     */
    numeroLote?: number;

    /**
     * Codigo do escritorio
     */
    codigoEscritorio?: number;

    /**
     * Numero do sinistro
     */
    anoSinistro?: number;
  }

  /**
   * Parameters for obterLotePaginadoPorNumero
   */
  export interface ObterLotePaginadoPorNumeroParams {

    /**
     * Quantidade registros por pagina
     */
    perPage: number;

    /**
     * Pagina inicial
     */
    page: number;

    /**
     * Codigo identificador do lote
     */
    numeroLote: number;
  }
}

export { LoteHonorarioService }
